module.exports = __webpack_public_path__ + "img/cayman-islands.c10ca3bf.png";